'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wraps any component and overlays a file input.
 */
var FileButton = function (_React$Component) {
  (0, _inherits3.default)(FileButton, _React$Component);

  function FileButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FileButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FileButton.__proto__ || (0, _getPrototypeOf2.default)(FileButton)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      var handler = _this.props.onChange;
      if (handler) handler(e.target.files);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FileButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = (0, _objectWithoutProperties3.default)(_props, ['children']);

      return _react2.default.createElement(
        'div',
        { className: 'FileButton' },
        children,
        _react2.default.createElement('input', (0, _extends3.default)({
          multiple: false,
          value: ''
        }, props, {
          type: 'file',
          onChange: this.onChange,
          className: 'FileButton__input'
        }))
      );
    }
  }]);
  return FileButton;
}(_react2.default.Component);

exports.default = FileButton;


FileButton.propTypes = {
  onChange: _propTypes2.default.func,
  children: _propTypes2.default.element
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/FileButton/index.js
// module id = 186
// module chunks = 0